import React from 'react'

function Icon({active = '#202020'}) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 16 16">
      <path
        fill={active}
        fillOpacity="0.5"
        d="M14 12H4a.666.666 0 100 1.333h10v1.334H4a2 2 0 01-2-2v-10a1.333 1.333 0 011.333-1.334H14V12zM3.333 10.7c.108-.022.22-.033.334-.033h9v-8H3.333V10.7zM10.667 6H5.333V4.667h5.334V6z"
      ></path>
    </svg>
  )
}

export default Icon
